import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  handleSubmit(event) {
    const formData = new FormData(event.target);
    const selectedOption = formData.get("bdm_certificate[status]");

    if (selectedOption === "accepted") {
      this.showModal("#modal-bdm_review_accept");
    } else if (selectedOption === "rejected") {
      this.showModal("#modal-bdm_review_reject");
    }
  }

  showModal(modalSelector) {
    const modal = document.querySelector(modalSelector);

    if (modal) {
      window.HSOverlay.open(modalSelector);
      this.modalOpen = true;
    }
  }
}
